import jQuery from "jquery";

export default function(refreshCallback = null) {
	let defaultLayoutOption = '';
	let layoutButtons = jQuery('*[data-product-list-layout]');

	jQuery('*[data-product-list-layout]:first-child').each(function() {
		defaultLayoutOption = jQuery(this).data('product-list-layout');
	});

	layoutButtons.click(function () {
		const layout = jQuery(this).data('product-list-layout');
		sessionStorage.setItem('product-list-layout', layout);
		refreshLayout(doRefresh);
	});

	// if the user already has a layout stored in sessionStorage
	refreshLayout(doRefresh);

	function refreshLayout(callback) {
		const layout = sessionStorage.getItem('product-list-layout') || defaultLayoutOption;
		const lists = jQuery('.element--product-list--mini');

		layoutButtons.removeClass('active');
		jQuery(`*[data-product-list-layout="${layout}"]`).addClass('active');

		layoutButtons.each(function () {
			const layout = jQuery(this).data('product-list-layout');
			lists.removeClass(layout);
		});
		lists.addClass(layout);

		if (callback && typeof(callback) === 'function') {
			callback(layout);
		}
	}

	function doRefresh() {
		setTimeout(refreshCallback, 1000);
	}
}
